export default {
  title: "Invitation",
  description: "You have been invited to collaborate on an event",
  status: {
    pending: "Pending",
    accepted: "Accepted",
    declined: "Declined",
    expired: "Expired"
  },
  resourceTypes: {
    budget: "Budget",
    guests: "Guests",
    tasks: "Tasks",
    timeline: "Timeline",
    vendors: "Vendors",
    events: "Events"
  },
  accessLevels: {
    view: "View only",
    edit: "Edit",
    manage: "Full management"
  },
  actions: {
    accept: "Accept",
    decline: "Decline"
  },
  accessLevel: "Access level",
  expiresAt: "Expires on",
  invitedBy: "Invited by",
  unknownUser: "Unknown user",
  success: {
    accepted: "Invitation accepted successfully",
    declined: "Invitation declined"
  },
  errors: {
    invalidToken: "Invalid invitation token",
    notFound: "Invitation not found",
    expired: "This invitation has expired",
    accept: "Error accepting invitation",
    decline: "Error declining invitation",
    loadInvitation: "Error loading invitation",
    pendingInvitation: "Error checking pending invitations"
  },
  landing: {
    welcome: "Welcome, {{name}}!",
    welcomeGeneric: "Shared Access",
    subtitle: "Enter your email to access shared resources",
    subtitleAuthenticated: "You have been invited to collaborate on this event.",
    confirmIdentity: "Confirm your identity to access the secure space reserved for",
    emailLabel: "Email address",
    emailPlaceholder: "your@email.com",
    emailHelp: "Use the email address you received the invitation with",
    submitButton: "Access the space",
    validating: "Validating...",
    securityTitle: "Security info",
    securityPoint1: "This link is unique and secure",
    securityPoint2: "Access is strictly reserved for the invited email",
    securityPoint3: "No account creation is required",
    errorToken: "Missing sharing token in URL",
    errorValidation: "Invalid link or incorrect email. Check that you are using the correct email address.",
    errorGeneric: "An error occurred during validation"
  }
};
